export enum AttributeStatusTypes {
    NEW = "new",
    ASYNC_INCOMPLETE = "async-incomplete",
    PICKER = "picker",
    PLACEHOLDER = "placeholder",
    PIN = "pin",
    RETRY = "retry",
    FAIL = "fail",
    PASS = "pass"
}